import React, { useState, useEffect, useId } from "react";
import { v4 as uuid } from "uuid";
import { MyContext } from "./MyContext";

export const Container = (props) => {
  const ID = useId();
  const UUID = uuid();

  const tasks = [];

  const [items, setItems] = useState(tasks);
  const [value, setValue] = useState("");

  const toDos = items.filter((item) => !item.done);
  const toDones = items.filter((item) => item.done);

  useEffect(() => {
    const tasks = JSON.parse(localStorage.getItem("todos"));
    if (tasks) {
      setItems(tasks);
    }
  }, [items]);

  const addItem = (value) => {
    const newItem = {
      id: `${ID}${UUID}`,
      text: value,
      done: false,
    };
    const updatedtasks = [...items, newItem];
    setItems(updatedtasks);
    localStorage.setItem("todos", JSON.stringify(updatedtasks));
  };

  const updateItem = (id) => {
    const updatedItems = items.map((item) => {
      if (item.id === id) {
        item.done = !item.done;
        return item;
      } else return item;
    });
    setItems(updatedItems);
    localStorage.setItem("todos", JSON.stringify(updatedItems));
  };

  const restoreItem = () => {
    const restoreItems = items.map((item) => {
      if (item.done) {
        item.done = !item.done;
        return item;
      } else return item;
    });
    setItems(restoreItems);
    localStorage.setItem("todos", JSON.stringify(restoreItems));
  };

  const removeItem = (id) => {
    const remove = items.filter((item) => item.id !== id);
    if (remove) {
      localStorage.removeItem("todos");
    }
    setItems(remove);
    localStorage.setItem("todos", JSON.stringify(remove));
  };

  const removeAllDoneItems = () => {
    const remove = items.filter((item) => !item.done);
    remove && localStorage.removeItem("todos");
    setItems(remove);
    localStorage.setItem("todos", JSON.stringify(remove));
  };

  const showLengthToDoItems = () => {
    const tasks =
      toDos.length === 1 ? `${toDos.length} task` : `${toDos.length} tasks`;
    return tasks;
  };

  const showLengthtoDoneItems = () => {
    const showDeletedTasks =
      toDones.length === 1
        ? `${toDones.length} task`
        : `${toDones.length} tasks`;
    return showDeletedTasks;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (value.trim()) addItem(value);
    setValue("");
  };

  const STYLES = {
    textField: {
      backgroundColor: "rgba(255, 255, 255, 0.9)",
      border: "1px solid rgba(120, 119, 198, 0.2)",
      borderRadius: "12px",
      color: "#2d3748",
      fontSize: "1rem",
      fontWeight: "500",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    },
    todo: {
      color: "#2d3748",
      fontSize: "1rem",
      fontWeight: "600",
      // marginTop: "1rem",
    },
    done: {
      backgroundColor: "rgba(248, 250, 252, 0.8)",
      color: "#64748b",
      fontSize: "0.9rem",
      textDecoration: "line-through",
      opacity: "0.85",
      // marginTop: "1rem",
    },
    todoText: {
      textAlign: "start",
      // margin: "1.5rem 0 0.75rem 0",
      // padding: "1rem 0 0 0",
      color: "#2d3748",
      fontWeight: "700",
      fontSize: "1.25rem",
      letterSpacing: "-0.02em",
      textShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      backgroundClip: "text",
    },
    doneText: {
      textAlign: "start",
      // margin: "1.5rem 0 0.75rem 0",
      // padding: "1rem 0 0 0",
      backgroundColor: "transparent",
      color: "#64748b",
      fontWeight: "600",
      fontSize: "1.25rem",
      // letterSpacing: "-0.01em",
      // borderLeft: "4px solid #cbd5e1",
      // paddingLeft: "1rem",
    },
    restoreFromTrashBtn: {
      margin: "0.75rem 0",
      letterSpacing: "0.025em",
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      color: "#fff",
      border: "none",
      borderRadius: "8px",
      // padding: "0.875rem 1.5rem",
      fontSize: "1rem",
      fontWeight: "600",
      boxShadow: "0 4px 12px rgba(102, 126, 234, 0.3)",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      textTransform: "none",
    },
    deleteAllDoneBtn: {
      margin: "0.75rem 0",
      letterSpacing: "0.025em",
      background: "linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%)",
      color: "#ffffff",
      border: "none",
      borderRadius: "8px",
      // padding: "0.875rem 1.5rem",
      fontSize: "1rem",
      fontWeight: "600",
      boxShadow: "0 4px 12px rgba(255, 107, 107, 0.3)",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      textTransform: "none",
    },
  };

  return (
    <MyContext.Provider
      value={{
        addItem,
        updateItem,
        toDos,
        toDones,
        restoreItem,
        removeItem,
        removeAllDoneItems,
        showLengthToDoItems,
        showLengthtoDoneItems,
        handleSubmit,
        value,
        setValue,
        STYLES,
      }}
    >
      {props.children}
    </MyContext.Provider>
  );
};
